import ICON_GOV from '@/assets/korUploadFile/icon_24.png';
import { Icon } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  onClick?: () => void;
};

const Accordian = ({ onClick }: Props) => {
  return (
    <Button type='button' onClick={onClick}>
      <img src={ICON_GOV} alt='' width={24} />
      정부24 회원이 아니신가요?
      <IconChevronDown />
    </Button>
  );
};
export default Accordian;

const Button = styled.button`
  display: flex;
  align-items: center;
  gap: 16px;
  color: #111;
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.36px;
  border-top: 1px solid #e5e6e8;
  border-bottom: 1px solid #e5e6e8;
  padding: 20px;
  width: 100%;
`;

const IconChevronDown = styled(Icon.ChevronDown)`
  margin-left: auto;
`;
